import { Label } from '@/components/ui/label';
import { SearchInput } from '@/components/ui/search-input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

import { type AuditPeriod } from './_filter-options';
import { PeriodSelect } from './PeriodSelect';

/* ------------------------------------------------------------------ */
/*  Constants                                                          */
/* ------------------------------------------------------------------ */

// "Enviado" reflete a semântica publish-only do dispatcher (publicou no
// Redis Stream). O valor PROCESSED é o enum técnico no backend e fica
// como está — só o label visível ao admin muda.
const STATUS_OPTIONS: { value: string; label: string }[] = [
  { value: 'PENDING', label: 'Pendente' },
  { value: 'PROCESSING', label: 'Processando' },
  { value: 'PROCESSED', label: 'Enviado' },
  { value: 'FAILED', label: 'Falhou' },
  { value: 'DEAD', label: 'Dead' },
];

/* ------------------------------------------------------------------ */
/*  Component                                                          */
/* ------------------------------------------------------------------ */

interface OutboxFilterBarProps {
  search: string;
  onSearchChange: (value: string) => void;
  status: string;
  onStatusChange: (value: string) => void;
  eventType: string;
  onEventTypeChange: (value: string) => void;
  eventTypes: string[];
  period: AuditPeriod;
  onPeriodChange: (value: AuditPeriod) => void;
  hideStatus?: boolean;
}

export function OutboxFilterBar({
  search,
  onSearchChange,
  status,
  onStatusChange,
  eventType,
  onEventTypeChange,
  eventTypes,
  period,
  onPeriodChange,
  hideStatus,
}: OutboxFilterBarProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-end">
      <div className="space-y-1">
        <Label className="text-xs font-medium">Buscar</Label>
        <SearchInput
          value={search}
          onChange={onSearchChange}
          placeholder="correlation_id..."
          className="w-full sm:w-[200px]"
        />
      </div>

      {!hideStatus && (
        <div className="space-y-1">
          <Label className="text-xs font-medium">Status</Label>
          <Select value={status} onValueChange={onStatusChange}>
            <SelectTrigger className="w-full sm:w-[140px]">
              <SelectValue placeholder="Todos" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="__all__">Todos</SelectItem>
              {STATUS_OPTIONS.map((o) => (
                <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}

      <div className="space-y-1">
        <Label className="text-xs font-medium">Tipo de evento</Label>
        <Select value={eventType} onValueChange={onEventTypeChange}>
          <SelectTrigger className="w-full sm:w-[180px]">
            <SelectValue placeholder="Todos" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="__all__">Todos</SelectItem>
            {eventTypes.map((t) => (
              <SelectItem key={t} value={t}>{t}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <PeriodSelect<AuditPeriod> value={period} onChange={onPeriodChange} />
    </div>
  );
}
